import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const MediaAndComplianceCheck = () => (
    <ECommerce.MediaAndComplianceCheck />
);

export default memo(MediaAndComplianceCheck);
